export default __webpack_public_path__ + "static/media/googleAnalytics.9eb0b37d.svg";